module.exports = __webpack_public_path__ + "static/erickson1thumb-4853f7aa809da41888922570945774b1.jpg";